import { usePermissions } from '@/shared/permissions';

import { CONTENT_PERMISSIONS } from '../model/permissions';

export function useContentPermissions() {
  const { hasPermission } = usePermissions();

  return {
    canView: hasPermission(CONTENT_PERMISSIONS.view),
    canManage: hasPermission(CONTENT_PERMISSIONS.manage),
  };
}

